import { InsightContentSettingType } from 'components/insightContent/types'
import { getSelectionName } from 'components/insightContent/utils/utils'
import { InsightData } from 'schemas/action/InsightDataSchema'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from 'utils/widgetUtil'
import { SocialWebDomainsWidget } from 'schemas/SocialWebDomainsWidgetSchema'
import { FilterTypeStrings } from 'enums/FilterType'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import InsightViewOption from 'enums/InsightViewOption'

export const convertToInsightContentSetting = (
  widgetSetting: SocialWebDomainsWidget,
  strategy: SearchFilterComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [] as FilterTypeStrings[],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic?.topicId,
    insights: selection ? selection?.insights : null,
    displayTitleTooltip: viewOption !== InsightViewOption.SUBREDDITS
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const insights = selection ? selection?.insights : null

  if (insights && insights.length > 0) {
    insightContentSetting.selectionName = getSelectionName(insights?.[0], viewOption)!
    // TODO: maybe handle selection names with array for multiple selections
    if (insights.length > 1) {
      if (insights.length === 2) {
        insightContentSetting.selectionSecondName = getSelectionName(insights?.[1], viewOption)!
      }
    }

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: SocialWebDomainsWidget,
  strategy: WidgetSettingComposingStrategy,
  selection: { insights?: Array<InsightData> }
) => {
  if (widgetSetting && typeof widgetSetting === 'object') {
    return composeDrillDownWidgetSetting(strategy, widgetSetting, selection.insights!)
  }
  return {}
}
